import { gql } from '@apollo/client';

export const REGIONS = gql`
  query getAvailableRegions($inputCountry: Country, $inputRegion: String!) {
    getAvailableRegions(inputCountry: $inputCountry, inputRegion: $inputRegion)
  }
`;
